$( document ).ready(function() {

    /*when user change pack count*/
    $('.pack-count-selector').on('click', function(){
        selectPackCount($(this))
    });

    /*action on btn click for add to bundle*/
    $('.btn-add-to-bundle').on('click', function(){
        selectProductForBundle($(this));
        updateBundleTotalPrice();
    });

    /*action for remove product from bundle*/
    $('.bundle-product-remove').on('click', function(){
        removeProductFromBundle($(this))
        updateBundleTotalPrice();
    });

    $(window).on('scroll', function() {
        let distanceToTop = $('#line-show-sticky-mobile')[0].getBoundingClientRect().top;

        if (distanceToTop <= 100) {
            $('#sticky-bar-on-mobile').fadeIn(); // or .addClass('visible'), etc.
        } else {
            $('#sticky-bar-on-mobile').fadeOut(); // or .removeClass('visible')
        }
    });

    setTotalPriceToTextBlock('subscribe-bundle');

    $('#subscribe-delivery-period select').on('change', function(){
        let selectedPlanName = $(this).val();
        $(`select.product-selling-plan-selector option`).attr('selected',false);
        $(`select.product-selling-plan-selector option[data-attr-name="${selectedPlanName}"]`).attr('selected', 'true');
        $('select.product-selling-plan-selector option').each(function(){
            if($(this).is(':selected')) {
                let selling_plan_id = $(this).val();
                let product_id = $(this).data('product-id');
                $(`#add-to-bundle-${product_id}`).data('selling-plan-id', selling_plan_id);
                $(`div.pack-element-is-active[data-product-id="${product_id}"]`).attr('data-selling-plan-id', selling_plan_id);
            }
        });

        $('#subscribe-delivery-period-mobile select').prop('selected', false);
        $(`#subscribe-delivery-period-mobile select option[data-attr-name="${selectedPlanName}"]`).prop('selected', true);
    });

    $('#subscribe-delivery-period-mobile select').on('change', function(){
        let selectedPlanName = $(this).val();
        $(`select.product-selling-plan-selector option`).attr('selected',false);
        $(`select.product-selling-plan-selector option[data-attr-name="${selectedPlanName}"]`).attr('selected', 'true');
        $('select.product-selling-plan-selector option').each(function(){
            if($(this).is(':selected')) {
                let selling_plan_id = $(this).val();
                let product_id = $(this).data('product-id');
                $(`#add-to-bundle-${product_id}`).data('selling-plan-id', selling_plan_id);
                $(`div.pack-element-is-active[data-product-id="${product_id}"]`).attr('data-selling-plan-id', selling_plan_id);
            }
        });

        $('#subscribe-delivery-period select').prop('selected', false);
        $(`#subscribe-delivery-period select option[data-attr-name="${selectedPlanName}"]`).prop('selected', true);
    });

    $('#sticky-subscribe-type').click(function(){
        $("label[for='subscribe-bundle']").click();
        $('#sticky-subscribe-type, #sticky-onetime-type').removeClass('active-sticky-subscribe-type');
        $('#sticky-subscribe-type').addClass('active-sticky-subscribe-type');
    });
    $('#sticky-onetime-type').click(function(){
        $("label[for='one-time-bundle']").click();
        $('#sticky-subscribe-type, #sticky-onetime-type').removeClass('active-sticky-subscribe-type');
        $('#sticky-onetime-type').addClass('active-sticky-subscribe-type');
    });

    $('.current-bundle-type-selector input[type="radio"]').click(function(){
        initCheckFullPack();
        let currentBundleType = $('input[name="current-bundle-type"]:checked').attr('id');
        let priceBlockSubscribe = $('.price-block-subscribe');
        let priceBlockOneTime = $('.price-block-one-time');

        setTotalPriceToTextBlock(currentBundleType);
        updateBundleTotalPrice();

        $('#sticky-subscribe-type, #sticky-onetime-type').removeClass('active-sticky-subscribe-type');

        if(currentBundleType == 'subscribe-bundle') {
            priceBlockSubscribe.show();
            priceBlockOneTime.hide();
            $('.bundle-under-cta-text').show();
            $('#subscribe-delivery-period, #subscribe-delivery-period-mobile').fadeIn(300);
            $('#sticky-subscribe-type').addClass('active-sticky-subscribe-type');
        }
        if(currentBundleType == 'one-time-bundle') {
            priceBlockSubscribe.hide();
            priceBlockOneTime.show();
            $('.bundle-under-cta-text').hide();
            $('#subscribe-delivery-period, #subscribe-delivery-period-mobile').fadeOut(300);
            $('#sticky-onetime-type').addClass('active-sticky-subscribe-type');
        }
    });
});

function getActualPrice(currentBundleType) {
    if(currentBundleType == 'subscribe-bundle') {
        return $('.active-pack-selector .price-block-subscribe .actual-price').text();
    }
    if(currentBundleType == 'one-time-bundle') {
        return $('.active-pack-selector .price-block-one-time .actual-price').text();
    }
}

function setTotalPriceToTextBlock(currentBundleType) {
    let actualPriceSubscribe = getActualPrice('subscribe-bundle');
    let actualPriceOneTime = getActualPrice('one-time-bundle');
    let blockForSubsPrice = $('#current-subscribe-price');
    let blockForOneTimePrice = $('#current-one-time-price');

    blockForSubsPrice.show().text(actualPriceSubscribe);
    blockForOneTimePrice.show().text(actualPriceOneTime);
}

function initBundleBuilder(selectedProductId, selectedProductBundleImage, selectedProductVariantId, selectedProductSellingPlanId) {
    const packSlotElement = $('.selected-bundle-products .pack-element');
    let productAdded = 0;
    packSlotElement.each(function(){
        if($(this).is(':visible') && !$(this).hasClass('pack-element-is-active') && productAdded === 0){
            $(this).addClass('pack-element-is-active');
            $(this).find('img.bundle-product-selected').attr('src', selectedProductBundleImage).fadeIn(400);
            $(this).attr("data-product-id", selectedProductId);
            $(this).attr("data-variant-id", selectedProductVariantId);
            if(selectedProductSellingPlanId != '') {
                $(this).attr("data-selling-plan-id", selectedProductSellingPlanId);
            }
            productAdded = 1;
        }
    });

    initCheckFullPack();
}

function initCheckFullPack() {
    /* check how many products we can add to bundle*/
    let totalSlotsForPackBundleProducts = 0;
    let totalOccupiedSlotsForPackBundleProducts = 0;
    const packSlotElement = $('.selected-bundle-products .pack-element');
    packSlotElement.each(function(){
        if($(this).is(':visible')){
            totalSlotsForPackBundleProducts ++;
        }
        if($(this).is(':visible') && $(this).hasClass('pack-element-is-active')) {
            totalOccupiedSlotsForPackBundleProducts ++;
        }
    });

    let totalFreeSlotsForPackBundleProducts = totalSlotsForPackBundleProducts-totalOccupiedSlotsForPackBundleProducts;

    $('#active-pack-count').text(totalFreeSlotsForPackBundleProducts);
    $('#active-pack-count-mobile').text(totalFreeSlotsForPackBundleProducts);

    if(totalFreeSlotsForPackBundleProducts == 1) {
        $('#pack-count-candles-title').text('bundle');
        $('#pack-count-candles-title-mobile').text('bundle');
    }else{
        $('#pack-count-candles-title').text('bundle');
        $('#pack-count-candles-title-mobile').text('bundle');
    }

    if(totalFreeSlotsForPackBundleProducts <= 0) {
        $('#btn-add-more-products').hide();
        $('#btn-add-more-products-mobile').hide();

        $('#btn-create-bundle').show();
        $('#btn-create-bundle-mobile').show();

        enableAddToCartBasedOnType('show');

        $('.btn-add-to-bundle').hide();
        $('.btn-full-bundle').show();
    } else {
        $('#btn-add-more-products').show();
        $('#btn-add-more-products-mobile').show();

        enableAddToCartBasedOnType('hide');

        $('.btn-add-to-bundle').show();
        $('.btn-full-bundle').hide();
    }
}

function enableAddToCartBasedOnType(action) {
    let currentBundleType = $('input[name="current-bundle-type"]:checked').attr('id');

    let btnSubscribe = $('.btn-create-bundle-subscribe')
    let btnOneTime = $('.btn-create-bundle-one-time');

    if(currentBundleType == 'subscribe-bundle' && action == 'show') {
        btnSubscribe.show();
        btnOneTime.hide();
    }
    if(currentBundleType == 'one-time-bundle' && action == 'show') {
        btnSubscribe.hide();
        btnOneTime.show();
    }
    if(currentBundleType == 'subscribe-bundle' && action == 'hide') {
        btnSubscribe.hide();
        btnOneTime.hide();
    }
    if(currentBundleType == 'one-time-bundle' && action == 'hide') {
        btnSubscribe.hide();
        btnOneTime.hide();
    }
}

function selectProductForBundle(element) {
    const selectedProductId = element.data('product-id');
    const selectedProductVariantId = element.data('variant-id');
    const selectedProductBundleImage = element.data('product-bundle-image');
    const selectedProductSellingPlanId = element.data('selling-plan-id');

    initBundleBuilder(selectedProductId, selectedProductBundleImage, selectedProductVariantId, selectedProductSellingPlanId);
}

function selectPackCount(element) {
    const packCount = parseInt(element.data('pack-count'));
    let currentBundleType = $('input[name="current-bundle-type"]:checked').attr('id');
    $('.pack-count-selector').removeClass('active-pack-selector');

    element.addClass('active-pack-selector');

    let count = 1;
    $('.pack-elements-bag .pack-element').each(function (){
        if(count > packCount) {
            $(this).fadeOut(300);
        }else{
            $(this).fadeIn(300);
        }
        count++;
    });

    setTimeout(function () {
        initCheckFullPack();
        setTotalPriceToTextBlock(currentBundleType);
        updateBundleTotalPrice();
    },500);
}

function removeProductFromBundle(element) {
    element.parent().attr('data-product-id','');
    element.parent().attr('data-variant-id','');
    element.parent().removeClass('pack-element-is-active');
    element.parent().find('img.bundle-product-selected').hide();
    setTimeout(function () {
        initCheckFullPack();
    },200);
}

function createSubscribeProductsBundle() {
    let items = [];

    const packSlotElement = $('.selected-bundle-products .pack-element');
    packSlotElement.each(function(){
        if($(this).is(':visible') && $(this).hasClass('pack-element-is-active')) {
            let productsList = {};
            productsList.id = $(this).attr('data-variant-id');
            productsList.quantity = 1;
            productsList.selling_plan = $(this).attr('data-selling-plan-id');
            items.push(productsList);
        }
    });

    let data = {
        'items' : items
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (e) {
            initCart();
            showSmallCart();
        },error:function(error){
            console.log(error);
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function createSingleProductsBundle() {

    let items = [];

    const packSlotElement = $('.selected-bundle-products .pack-element');
    packSlotElement.each(function(){
        if($(this).is(':visible') && $(this).hasClass('pack-element-is-active')) {
            let productsList = {};
            productsList.id = $(this).attr('data-variant-id');
            productsList.quantity = 1;
            items.push(productsList);
        }
    });

    let data = {
        'items' : items
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (e) {
            initCart();
            showSmallCart();
        },error:function(error){
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function updateBundleTotalPrice() {
    let totalPrice = 0;
    let selectedCount = 0;

    $('.selected-bundle-products .pack-element.pack-element-is-active:visible').each(function () {
        const productId = $(this).attr('data-product-id');
        if (productId) {
            const price = parseFloat($(`#add-to-bundle-${productId}`).data('product-price'));
            if (!isNaN(price)) {
                totalPrice += price;
                selectedCount++;
            }
        }
    });

    let discountSub = 0;
    if (selectedCount === 2) discountSub = 0.15;
    else if (selectedCount === 4) discountSub = 0.15;
    else if (selectedCount === 6) discountSub = 0.15;

    let discountOneTime = 0;
    if (selectedCount === 4) discountOneTime = 0;
    else if (selectedCount === 6) discountOneTime = 0.10;

    const totalSub = totalPrice * (1 - discountSub);
    const totalOneTime = totalPrice * (1 - discountOneTime);

    if (selectedCount > 0) {
        $('.total-price-subscription').removeClass('hidden');
        $('.total-price-one-time').removeClass('hidden');
    } else {
        $('.total-price-subscription').addClass('hidden');
        $('.total-price-one-time').addClass('hidden');
    }

    $('.total-price-subscription').text(`$${totalSub.toFixed(2)}`);
    $('.total-price-one-time').text(`$${totalOneTime.toFixed(2)}`);

    $('.total-price-subscription-mobile').text(`$${totalSub.toFixed(2)}`);
    $('.total-price-one-time-mobile').text(`$${totalOneTime.toFixed(2)}`);
}